module.exports = "pegasus/assets/3column-card.png";